import { FilterItem } from 'baby-ui/types'

export const createCheckedItemLabelList = (filterItems: FilterItem[]) =>
  filterItems.filter(({ checked }) => checked).map(({ label }) => label)
